<k-area-blocker [showLoader]="_showLoader">
  <div class="kOverrideFAIcons kRefineFilters">
    <kScrollToTopContainer #refine class="kTreeContainer">
      <div class="kFiltersGroupTitle">
        <span>{{ 'applications.content.filters.additionalFilters' | translate | uppercase }}</span>
      </div>
      <p>{{ 'applications.content.filters.createdBetween' | translate }}</p>
      <div class="kDateRange">
        <p-calendar
          class="kDateRangeFirst"
          [(ngModel)]="_createdAfter"
          [readonlyInput]="true"
          [showIcon]="true"
          [monthNavigator]="true"
          [yearNavigator]="true"
          [yearRange]="_createdAtDateRange"
          [dateFormat]="_calendarFormat"
          [locale]="_calendarLocale"
          icon="kIconcalendar"
          (onSelect)="_onCreatedChanged()"
        ></p-calendar>
        <p-calendar
          class="kDateRangeLast kPullLeft100"
          [(ngModel)]="_createdBefore"
          [readonlyInput]="true"
          [dateFormat]="_calendarFormat"
          [showIcon]="true"
          [monthNavigator]="true"
          [yearNavigator]="true"
          [yearRange]="_createdAtDateRange"
          [locale]="_calendarLocale"
          icon="kIconcalendar"
          (onSelect)="_onCreatedChanged()"
        ></p-calendar>
      </div>
      <a
        class="kClearAll"
        (click)="_clearCreatedComponents()"
        [class.kDisabledLink]="!_createdAfter && !_createdBefore"
      >
        {{ 'applications.content.filters.clearDates' | translate }}</a
      >
      <span *ngIf="_createdFilterError" class="kError">{{ _createdFilterError }}</span>
      <div *ngFor="let group of _primeListsGroups">
        <div *ngIf="group.label" class="kFiltersGroupTitle">
          <span>{{ group.label | uppercase }}</span>
        </div>
        <div *ngFor="let treeInstance of group.lists">
          <p-tree
            [value]="treeInstance.items"
            [selectionMode]="'checkbox'"
            kRefinePrimeTree
            [(selection)]="treeInstance.selections"
            (onNodeSelect)="_onTreeNodeSelect($event, treeInstance)"
            (onNodeUnselect)="_onTreeNodeUnselect($event, treeInstance)"
          >
            <ng-template let-node pTemplate="default">
              <div class="kTreeNodeLabelWrapper">
                <span class="kTreeNodeLabel" [kTooltip]="node.label" [delay]="1000">
                  {{ node.label }}
                </span>
              </div>
              <div *ngIf="node.value === 'scheduled'" (click)="_blockScheduleToggle($event)">
                <div class="kDateRange">
                  <p-calendar
                    class="kDateRangeFirst"
                    #scheduledfrom
                    [(ngModel)]="_scheduledAfter"
                    [showIcon]="true"
                    icon="kIconcalendar"
                    [disabled]="!_scheduledSelected"
                    [monthNavigator]="true"
                    [yearNavigator]="true"
                    [yearRange]="_createdAtDateRange"
                    [readonlyInput]="true"
                    [dateFormat]="_calendarFormat"
                    [locale]="_calendarLocale"
                    (onBlur)="_fixCalendarBlurPropagation($event, scheduledfrom)"
                    (onSelect)="_onSchedulingChanged(scheduledfrom)"
                  ></p-calendar>
                  <p-calendar
                    class="kDateRangeLast kPullLeft120"
                    #scheduledto
                    [(ngModel)]="_scheduledBefore"
                    [showIcon]="true"
                    icon="kIconcalendar"
                    [disabled]="!_scheduledSelected"
                    [monthNavigator]="true"
                    [yearNavigator]="true"
                    [yearRange]="_createdAtDateRange"
                    [readonlyInput]="true"
                    [dateFormat]="_calendarFormat"
                    [locale]="_calendarLocale"
                    (onBlur)="_fixCalendarBlurPropagation($event, scheduledto)"
                    (onSelect)="_onSchedulingChanged(scheduledto)"
                  ></p-calendar>
                </div>
                <span *ngIf="_scheduledSelected && _scheduledFilterError" class="kError">{{
                  _scheduledFilterError
                }}</span>
              </div>
            </ng-template>
          </p-tree>
        </div>
      </div>
    </kScrollToTopContainer>

    <p>
      <a class="clearAll" (click)="_clearAllComponents()">{{ 'applications.content.filters.clearAll' | translate }}</a>
      <a class="kClose" (click)="_close()">{{ 'applications.content.filters.close' | translate }}</a>
    </p>
  </div>
</k-area-blocker>
